import { AssociatedMemberType } from 'src/enums/associated-member-type';

export enum DigitalSignatureLevel {
  OFF = 'OFF',
  SES_PRIMARY_ONLY = 'SES_PRIMARY_ONLY',
  SES_PRIMARY_AND_ADULTS = 'SES_PRIMARY_AND_ADULTS',
  AES_PRIMARY_ONLY = 'AES_PRIMARY_ONLY',
  AES_PRIMARY_AND_ADULTS = 'AES_PRIMARY_AND_ADULTS',
}

export const shouldCollectAdultSignatures = (
  digitalSignatureLevel: DigitalSignatureLevel
): boolean => {
  switch (digitalSignatureLevel) {
    case DigitalSignatureLevel.AES_PRIMARY_AND_ADULTS:
    case DigitalSignatureLevel.SES_PRIMARY_AND_ADULTS:
      return true;
    case DigitalSignatureLevel.AES_PRIMARY_ONLY:
    case DigitalSignatureLevel.SES_PRIMARY_ONLY:
    case DigitalSignatureLevel.OFF:
      return false;
  }
};

export const shouldCollectAes = (digitalSignatureLevel: DigitalSignatureLevel): boolean => {
  switch (digitalSignatureLevel) {
    case DigitalSignatureLevel.AES_PRIMARY_AND_ADULTS:
    case DigitalSignatureLevel.AES_PRIMARY_ONLY:
      return true;
    case DigitalSignatureLevel.SES_PRIMARY_AND_ADULTS:
    case DigitalSignatureLevel.SES_PRIMARY_ONLY:
    case DigitalSignatureLevel.OFF:
      return false;
  }
};

export const shouldShowDataCaptureNameHintForMember = (
  digitalSignatureLevel: DigitalSignatureLevel,
  associatedMemberType?: AssociatedMemberType
): boolean => {
  if (!shouldCollectAes(digitalSignatureLevel)) {
    return false;
  }

  const isPrimaryMember = !associatedMemberType;
  if (isPrimaryMember) {
    return true;
  }

  const isAdultAssociate =
    associatedMemberType === AssociatedMemberType.ADULT ||
    associatedMemberType === AssociatedMemberType.NANNY;
  return shouldCollectAdultSignatures(digitalSignatureLevel) && isAdultAssociate;
};
